import { cn } from '@seen/ui'
import { IconStethoscope } from '@tabler/icons-react'
import type { ReactNode } from 'react'

export function IconOrder({ className }: { className?: string }): ReactNode {
  return <IconStethoscope className={cn('size-4 shrink-0', className)} />
}
